import { DotNet } from '@microsoft/dotnet-js-interop';
import {
    createEditor,
    $getRoot,
    $getNodeByKey,
    $createParagraphNode, $createTextNode,
    $getSelection, $isRangeSelection,
    COMMAND_PRIORITY_LOW, $insertNodes,
    CAN_REDO_COMMAND,
    CAN_UNDO_COMMAND,
    CUT_COMMAND,
    COPY_COMMAND,
    PASTE_COMMAND,
    LexicalNode,
    LexicalEditor
} from "lexical";
import {QuoteNode, registerRichText} from "@lexical/rich-text";
import {createEmptyHistoryState, registerHistory} from "@lexical/history";
import {
    $generateHtmlFromNodes,
    $generateNodesFromDOM
} from "@lexical/html";

import * as Commands from "./lexical-editor-commands";
import lexicalEditorConfig from "./lexical-editor-config.ts";
import LexicalEditorLinkPlugin from "./plugins/link-plugin";
import LexicalEditorMediaPlugin from "./plugins/media-plugin";

export function Create(dotNetRef: DotNet.DotNetObject, id: string): LexicalEditor{
    console.log('LexicalEditor Create. id:' + id);

    let editor = createEditor(lexicalEditorConfig);

    editor.setRootElement(document.getElementById(id));

    registerRichText(editor);
    registerHistory(editor, createEmptyHistoryState(), 1000);

    registerDotNetListeners(editor, dotNetRef);
    (window as any).LexicalEditorInstance = editor;
    return editor;
}

function registerDotNetListeners(editor: LexicalEditor, dotNetRef: DotNet.DotNetObject) {

    editor.registerUpdateListener(({editorState}) => {
        editorState.read(() => {

            const html = $generateHtmlFromNodes(editor);
            const nodes = JSON.stringify(editorState.toJSON(), null, 2);

            dotNetRef.invokeMethodAsync('OnEditorChanged', nodes, html);
        });
    });
}

function SetNodeValue(editor: LexicalEditor, value: any) {

    if (value === null || value === undefined) {
        return;
    }

    const editorState = editor.parseEditorState(value);
    editor.setEditorState(editorState);
}

function SetHtmlValue(editor: LexicalEditor, value : string) {

    editor.update(() => {
        const parser = new DOMParser();
        const dom = parser.parseFromString(value, 'text/html');

        // root node should always be <p> https://github.com/facebook/lexical/issues/4226

        const nodes = $generateNodesFromDOM(editor, dom);
        $getRoot().clear();
        $getRoot().select();
        $insertNodes(nodes);
    });
}

export default {
    Create,
    SetHtmlValue,
    SetNodeValue,
    Commands,
    LinkPlugin: LexicalEditorLinkPlugin,
    MediaPlugin: LexicalEditorMediaPlugin
};
